"use strict"

window.MESSAGES={};

const TTL=10000;
const REFRESH_TTL=5000;
const FADEOUT_TIME=2500;

const TIME_TO_POSITION=1500;

const PADDING=4;

const INTERVAL=50;
let TIMEOUT;

const POSITION_RIGHT=8;
const POSITION_BOTTOM=8;

export class Messages {
        
    static render(message) {

        switch (message.showAs) {
            case 'box':
                VutBox.alert(Messages.getBoxInner(message));
                break;
            default:
                let selector='';
                if (message.selector) {
                    let grid;
                    try {
                        if (document.querySelector(message.selector)) {
                            selector=message.selector;
                        } else {
                            selector='body';
                            console.warn('vutAjax: nenalezen element '+message.selector+' pro message');
                        }; 
                    } catch(e) {
                        console.warn('vutAjax: neplatný selector '+message.selector+' pro message');
                        selector='body';
                    }
                } else {
                    selector='body';
                }
                message.selector=selector;
                if (!Array.isArray(MESSAGES[selector])) {MESSAGES[selector]=[]}                    
                MESSAGES[selector].unshift(new Messages(message));
                Messages.startInterval();
                break;
        }
        
    }

    static getBoxInner(message) {
        
        let e=document.createElement('div');
        e.className="vutajax-box-message";
        e.innerHTML='<div class="-icon"><span class="icon-'+Messages.getIcon(message)+'"></span></div>';
        e.querySelector('.-icon').classList.add('-'+message.state);
        let td=document.createElement('div');
        td.className="-content";
        td.innerHTML=message.message;
        e.appendChild(td);
        return e.outerHTML;
            
        
    }

    static getParent(message) {
        let parent=document.querySelector(message.selector);
        if (!parent) return;
        let messageParent=document.querySelector(message.selector+'>.vutajax-message-point');
        if (!messageParent) {
            parent.insertAdjacentHTML('beforeend', '<div class="vutajax-message-point">');
            return Messages.getParent(message);
        }
        return messageParent;
    }

    static refreshAll() {
        Object.keys(MESSAGES).forEach((selector)=>{
            MESSAGES[selector].forEach((m)=>{
                if (REFRESH_TTL>m.ttl) {
                    m.ttl=REFRESH_TTL;
                    m.fromTtl=REFRESH_TTL;
                    m.interval_first=performance.now();
                }
            });
        });
        Messages.doInterval();
    }

    static getIcon(message) {
        switch ((typeof message.state === 'string')?message.state.toLowerCase():'') {
            case 'err':
            case 'error':
            case 'danger':
                return 'cancel-circle2';
            case 'warn':
            case 'warning':
                return 'notification2';
            case 'ok':
            case 'success':
                return 'checkmark-circle-vut';
            default:
                return 'info2';
                
        }
    }

    static svgPath (x, y, r, startAngle, endAngle) {

        if (startAngle > endAngle) {
          var s = startAngle;
          startAngle = endAngle;
          endAngle = s;
        }

        var largeArc = endAngle - startAngle <= Math.PI ? 0 : 1;

        return [
          "M", x, y,
          "L", x + Math.cos(startAngle) * r, y - Math.sin(startAngle) * r,
          "A", r, r, 0, largeArc, 0, x + Math.cos(endAngle) * r, y - Math.sin(endAngle) * r,
          "L", x, y
        ].join(" ");
                
    }

    static svg(message) {
        if (!message.svg) return;
        let angle=Math.round(((-2*message.ttl*Math.PI)/message.fromTtl)*100)/100;
        message.svg.innerHTML='<circle class="--outside" cx=12 cy=12 r=12></circle> <g id="arcs" transform=" translate(12 12) rotate(-90) scale(1 -1)"> <path d="'+Messages.svgPath(0,0,15,angle,0)+'"></path> </g> <circle class="--inside" cx=12 cy=12 r=10></circle>';
        let path=document.createElementNS("http://www.w3.org/2000/svg", 'path');
    }

    static getZIndex(element) {
        let ret=0;
        while (element.parentNode) {
            ret=Math.max(ret, parseFloat(window.getComputedStyle(element).zIndex)||0);
            element=element.parentNode;
        }
        return ret;
    }

    static position(messages, transitions) {
        if (messages.length) {
            let isBody=messages[0].parent.parentNode===document.body;
            let top=0;

            if (isBody) {
                let main=document.querySelector('.main');
                let content=document.querySelector('.main-content');
                if (main&&content) {
                    messages[0].parent.removeAttribute('style');
                    let cRect=content.getBoundingClientRect();
                    let mRect=main.getBoundingClientRect();
                    messages[0].parent.style.top=(Math.max(cRect.top, messages[0].parent.offsetTop))+'px';
                    messages[0].parent.style.width=(mRect.width-POSITION_RIGHT*2)+'px';
                    messages[0].parent.style.left=(messages[0].parent.offsetLeft-(document.documentElement.clientWidth-mRect.width-mRect.left))+'px';
                    messages[0].parent.style.right='auto';
                }
            } else {
                let parent=messages[0].parent.parentNode;
                
                let offsetParent=messages[0].parent.offsetParent;

                if (!(parent&&offsetParent)) { 
                    messages[0].getNewParent(); 
                    if (!(messages[0].parent&&(parent=messages[0].parent.parentNode))) {
                        messages.forEach((m)=>m.close()); 
                        return; 
                    } else {
                        messages.forEach((m, i)=>{
                            if (i) { 
                                messages[i].parent=messages[0].parent 
                                m.parent.appendChild(m.element);
                            }
                            transitions=false;
                        });                        
                    }
                    //Messages.position(messages, false);//cyklilo, když nebyl rodič :)
                    return;
                } else {
                    messages.forEach((m, i)=>{
                        if (i&&(messages[i].parent!=messages[0].parent)) {
                            messages[i].parent=messages[0].parent;
                            m.parent.appendChild(m.element);
                        }
                    });
                }

                messages[0].parent.style.width=(parent.offsetWidth-POSITION_RIGHT*2)+'px';


                let newTop=(parent.offsetHeight-messages[0].parent.offsetHeight);
                let newLeft=(parent.offsetWidth-/*POSITION_BOTTOM-*/POSITION_RIGHT-messages[0].parent.offsetWidth);

                switch (getComputedStyle(parent).position) {
                    case 'relative':
                    case 'absolute':
                    case 'fixed':
                    case 'sticky':
                        break;
                    default:
                        newTop+=parent.offsetTop;
                        newLeft+=parent.offsetLeft;
                        break;
                }

                messages[0].parent.style.left=newLeft+'px';
                messages[0].parent.style.top=(newTop)+'px';

                let pRect=messages[0].parent.getBoundingClientRect();
                if (pRect.top+POSITION_BOTTOM>document.documentElement.clientHeight) {
                    let minus=Math.min(pRect.top+POSITION_BOTTOM-document.documentElement.clientHeight, parent.offsetHeight-top);
                    messages[0].parent.style.top=(newTop-minus)+'px';
                } 

                messages[0].parent.style.zIndex=Messages.getZIndex(parent)+55;

            }

            messages.forEach((m)=>{               
                m.element.classList.remove('-height');
                if (m.element.offsetHeight>parseInt(getComputedStyle(m.element).minHeight)) {
                    m.element.classList.add('-height');                    
                }
                let height=m.element.offsetHeight
                if (!isBody) { top+=(top?PADDING:0)+height; }
                m.element.removeAttribute('style');
                m.element.setAttribute('style', ('top:'+(isBody?top:-top)+'px;')+(transitions?'':'transition:none;'));
                if (isBody) { top+=PADDING+height; }
            });

        }
    }

    static startInterval(transitions=true) {
        clearTimeout(TIMEOUT);
        if (/*document.hasFocus()&&*/Object.keys(MESSAGES).some((selector)=>MESSAGES[selector].length)) { TIMEOUT=setTimeout(Messages.doInterval, INTERVAL); }
    }

    static doInterval(transitions=true) { 

        clearTimeout(TIMEOUT);

        Object.keys(MESSAGES).forEach((selector)=>{
            MESSAGES[selector]=MESSAGES[selector].filter((m)=>!m.killed);
            if (!MESSAGES[selector].length) {
                delete MESSAGES[selector];
                let e;
                while (e=document.querySelector(selector+'>.vutajax-message-point:empty')) {e.parentNode.removeChild(e);}
            }
        });

        Object.keys(MESSAGES).forEach((selector)=>{
            MESSAGES[selector].forEach((m)=>{ 
                if (document.hasFocus()) {
                    if (m.getInView()&&(!m.element.matches(':hover, :active, .-timeout'))) {
                        let decrease=Math.min(performance.now()-m.interval_last, INTERVAL);
                        m.ttl=Math.max(m.ttl-decrease, 0);
                        if (!m.ttl) {m.kill();}
                        m.interval_last=performance.now();
                    } else if (REFRESH_TTL>m.ttl) {
                        m.interval_first=performance.now();
                        m.ttl=REFRESH_TTL;
                        m.fromTtl=REFRESH_TTL;                        
                    }
                }
                Messages.svg(m);
            });
            
            Messages.position(MESSAGES[selector], transitions);
            
        });
                
        if (/*document.hasFocus()&&*/Object.keys(MESSAGES).some((selector)=>MESSAGES[selector].length)) { TIMEOUT=setTimeout(Messages.doInterval, INTERVAL); }
                        
    }

    constructor(message) {
        this.interval_first=this.interval_last=performance.now();        
        this.message=message;
        this.render();
    }

    getInView() {
        
        if (!(this.element&&this.element.offsetParent)) return false;
        let rect=this.element.getBoundingClientRect();

        return ( 
            (performance.now()-this.interval_first>TIME_TO_POSITION)
            &&((rect.top>0)&&(rect.top+rect.height<document.documentElement.clientHeight))
            && (document.elementFromPoint(rect.left, rect.top) === this.element)
            && (document.elementFromPoint(rect.left+rect.width-1, rect.top) === this.element)
            && (document.elementFromPoint(rect.left, rect.top+rect.height-1) === this.element)
            && (document.elementFromPoint(rect.left+rect.width-1, rect.top+rect.height-1) === this.element)
        );
    }

    render() {
        this.ttl=TTL;
        this.fromTtl=TTL;

        this.parent=Messages.getParent(this.message);
        if (!this.parent) return (this.killed=true);

        this.element=document.createElement('div');
        this.element.className='vutajax-message -'+this.message.state;

        this.element.innerHTML='<span class="-icon"><span class="icon-'+Messages.getIcon(this.message)+'"></span></span>';

        let msg=document.createElement('span');
        msg.className='-content';
        msg.innerHTML=this.message.message;
        
        this.element.appendChild(msg);
        
        this.element.innerHTML+='<span class="-time"><span>'+((new Date).toTimeString().substr(0,8))+'</span></span>';
        
        this.svg=document.createElementNS("http://www.w3.org/2000/svg", "svg");
        
        let close=document.createElement('span');
        close.className='-message-close';
        close.innerHTML='<span class="icon-cross2"></span>';
        
        close.appendChild(this.svg);

        close.onclick=()=>this.close();
        
        this.element.appendChild(close);

        this.element.onmouseover=()=>this.refresh();
        this.element.ontouchstart=()=>this.refresh();
        
        this.parent.appendChild(this.element);
        
    }

    getNewParent() {
        this.parent=Messages.getParent(this.message);
        if (!this.parent) return (this.killed=true);
        this.parent.appendChild(this.element);
    }

    refresh() {
        if (this.ttl<REFRESH_TTL) {
            this.ttl=REFRESH_TTL; this.fromTtl=REFRESH_TTL;
        } else {
            this.ttl=TTL; this.fromTtl=TTL;            
        }
        this.interval_first=performance.now();
        this.element.classList.remove('-timeout');
        this.element.classList.remove('-dead');
        Messages.doInterval();        
    }

    close() {
        this.element.parentNode.removeChild(this.element);
        this.killed=true;
        Messages.doInterval();        
    }

    kill() {
        
        let msg=this;
        this.element.classList.add('-timeout');
        clearTimeout(this.fadeTimeout);
        this.fadeTimeout=setTimeout(()=>{
            if (msg.element.parentNode&&msg.element.matches('.-timeout')) { 
                msg.element.parentNode.removeChild(msg.element);
                msg.killed=true;
                Messages.doInterval();
            }
        }, FADEOUT_TIME);

    }


}

window.addEventListener('focus', Messages.refreshAll, false);
window.addEventListener('scroll', ()=>Messages.doInterval(false), true);
